import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ProgressBar from "../components/ProgressBar"; // 追加
import "../styles/CompleteProfile.css";

const hopeOptions = [
  { value: "カフェで会いたい", label: "カフェで会いたい" },
  { value: "ランチやディナーに行きたい", label: "ランチやディナーに行きたい" },
  { value: "オンラインで話したい", label: "オンラインで話したい" },
  { value: "一緒にイベントや美術館に行きたい", label: "一緒にイベントや美術館に行きたい" },
  { value: "まずはメッセージで話したい", label: "まずはメッセージで話したい" }
];

const CompleteProfile8 = () => {
  const [user] = useAuthState(auth);
  const [hope, setHope] = useState([]);
  const [error, setError] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      user.reload().then(() => {
        setEmailVerified(user.emailVerified);
      });

      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setHope(Array.isArray(data.hope) ? data.hope : []);
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      fetchProfile();
    }
  }, [user]);

  const handleSave = async () => {
    if (!emailVerified) {
      setError("メールアドレスの認証が完了していません。メールを確認してください。");
      return;
    }

    try {
      const userDocRef = doc(db, "members", user.uid);
      const docSnap = await getDoc(userDocRef);

      const profileData = {
        hope: hope
      };

      if (docSnap.exists()) {
        await updateDoc(userDocRef, profileData);
      } else {
        await setDoc(userDocRef, profileData);
      }

      navigate("/complete-profile3"); // 次のページへ
    } catch (error) {
      console.error("Error saving profile:", error.message);
      setError("プロフィールの保存中にエラーが発生しました。");
    }
  };

  return (
    <div className="complete-profile-container">
      <ProgressBar step={2} totalSteps={6} /> {/* 進捗バーを追加 */}

      <h2>会うときの希望を教えてください</h2>
      {error && <p className="error-message">{error}</p>}

      {emailVerified ? (
        <>
          <div className="form-group-a">
            <label>会うときの希望 <br></br>(複数選択可):</label>
            <Select
              name="hope"
              isMulti={true} // 複数選択を有効化
              isSearchable={false}
              value={hopeOptions.filter(option => hope.includes(option.value))}
              onChange={(selectedOptions) => setHope(selectedOptions.map(option => option.value))}
              options={hopeOptions}
              className="select-box"
            />
          </div>

          <button onClick={handleSave} className="complete-profile-button">次へ</button>
        </>
      ) : (
        <p>メールアドレスの認証が完了していません。メールを確認してください。</p>
      )}
    </div>
  );
};

export default CompleteProfile8;
